import { faCheck, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/layout";
// import PageHeader from "../../../components/pageHeader";
import { setUpdatedUserInfo } from "../../../redux/slices/userSlice";
import { RootState } from "../../../redux/store";
import { API_BASE_URL } from "../../../utils/useFetch";
import ProfileNav from "../components/profileNav";

const ProfileInfo = () => {
  const userInfo = useSelector((store: RootState) => store.user.userInfo);
  const dispatch = useDispatch();
  const [name, setName] = useState(userInfo ? userInfo.name : "");
  const [isSendingData, setIsSendingData] = useState(false);
  const fetchUpdateName = async () => {
    const _formData = new FormData();
    _formData.append("mobile", userInfo.mobile);
    _formData.append("code", userInfo.code);
    _formData.append("name", name);
    const response = await fetch(API_BASE_URL + "newupdatename", {
      method: "POST",
      body: _formData,
    });
    return response.json();
  };

  const handleClickUpdateName = () => {
    if (name.length < 4) {
      toast.error("لطفا نام خود را کامل بنویسید");
      return;
    }
    setIsSendingData(true);
    fetchUpdateName()
      .then((response) => {
        toast.success("نام شما با موفقیت ویرایش شد");
        dispatch(setUpdatedUserInfo(response.data));
      })
      .finally(() => {
        setIsSendingData(false);
      });
  };

  return (
    <Layout>
      {/* <PageHeader /> */}
      <section className='container mx-auto flex '>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div className='border-b border-solid'>
            <ProfileNav activeRoute={"/profile/info"} />
          </div>
          <div>
            <div className='flex-1 bg-white'>
              <div className='p-4 border-b flex items-center'>
                <div className='w-14'>شماره</div>
                <div className='flex-1'>
                  <input
                    className='p-2 border rounded text-center'
                    disabled
                    value={userInfo.mobile}
                  />
                </div>
              </div>
              <div className='p-4 border-b flex items-center'>
                <div className='w-14'>نام</div>
                <div>
                  <input
                    className='p-2 border rounded text-center'
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    disabled={isSendingData}
                  />
                </div>
                <button
                  className='mr-2 bg-rose-900 text-white py-2 px-3 rounded'
                  onClick={handleClickUpdateName}
                  disabled={isSendingData}
                >
                  {isSendingData ? (
                    <FontAwesomeIcon
                      icon={faCircleNotch}
                      className='rotate-animation'
                    />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} />
                  )}
                </button>
              </div>

              <div className='p-4 flex items-center hidden'>
                <div className='w-14'>کیف پول</div>
                <div className='flex-1'>
                  <input
                    className='p-2 border rounded text-center'
                    disabled
                    value={(userInfo.wallet ? userInfo.wallet : "0") + " تومان"}
                  />
                </div>
              </div>

              <div className='p-4 border-b flex hidden'>
                <div className='w-40'>
                  <div>جنسیت </div>
                </div>
                <div className='flex-1'>
                  <div className='flex items-center mb-4'>
                    <input
                      id='default-radio-1'
                      type='radio'
                      value=''
                      name='default-radio'
                      className='w-4 h-4 text-rose-900 bg-gray-100 border-gray-300 focus:ring-rose-900 dark:focus:ring-rose-900 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600'
                    />
                    <label
                      htmlFor='default-radio-1'
                      className='mr-2'
                    >
                      <div> خانم</div>
                    </label>
                  </div>
                  <div className='flex items-center'>
                    <input
                      checked
                      id='default-radio-2'
                      type='radio'
                      value=''
                      name='default-radio'
                      className='w-4 h-4 text-brose-900 bg-gray-100 border-gray-300 focus:ring-rose-900 dark:focus:ring-rose-900 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600'
                    />
                    <label
                      htmlFor='default-radio-2'
                      className='mr-2'
                    >
                      <div> آقا</div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};
export default ProfileInfo;
